interface PageErrorStateProps {
  title?: string;
  message: string;
  status?: number;
  onBackHome?: () => void;
}

function PageErrorState({ title = "שגיאה!", message, status, onBackHome }: PageErrorStateProps) {
  return (
    <>
      <h1>{title}</h1>
      {typeof status === "number" ? (
        <p>
          סטטוס קוד: <i>{status}</i>
        </p>
      ) : null}
      <p>
        הודעה: <i>{message}</i>
      </p>
      {onBackHome ? <button onClick={onBackHome}>חזור למסך הראשי</button> : null}
    </>
  );
}

export default PageErrorState;
